// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import useMatchBetFiltersContext from '../../hooks/useMatchBetFiltersContext';
import useMergeProps from '../../hooks/useMergeProps';

import MatchGroups from './MatchGroups';
import makeMatchGroupsPropsSelector from './MatchGroups.selector';

type MatchGroupsContainerProps = {
  matchId: number;
  filterId?: string | null;
};

const MatchGroupsContainer = (ownProps: MatchGroupsContainerProps) => {
  const { hash: locationHash, pathname } = useLocation();
  const { isHotFilterSelected } = useMatchBetFiltersContext();

  const selector = useMemo(() => makeMatchGroupsPropsSelector(), []);
  const selectorProps = useMemo(
    () => ({
      ...ownProps,
      locationHash,
      isHotFilterSelected,
    }),
    [locationHash, ownProps, isHotFilterSelected],
  );
  const selectedProps = useSelector((state) => selector(state, selectorProps));

  const enhancedProps = useMergeProps({ otherProps: { pathname }, selectedProps });

  return <MatchGroups {...enhancedProps} />;
};

export default React.memo<MatchGroupsContainerProps>(MatchGroupsContainer);
